module.exports = __webpack_public_path__ + "img/shoulder_width.999a1396.png";